module.exports = __webpack_public_path__ + "assets/images/premium-features/enable-tasks-dac8ac.png";